import { getUUID } from "./functions";
import { GRID_LENGTH } from "./constants";

// const ensureIsValidDeck = (deck) => {
//     const groudIds = new Set(deck.map(({ group }) => group));
//     const groups = [...groudIds].map((groupId) => deck.filter(({ group }) => group === groupId));

//     if (groups.length < MIN_DECK_GROUPS) {
//         throw new Error(`There must be at least ${MIN_DECK_GROUPS} groups`);
//     }

//     const allGroupsHasAtLeast3Cards = groups.every((group) => group.length >= MIN_GROUP_CARDS);

//     if (!allGroupsHasAtLeast3Cards) {
//         throw new Error(`There must be at least ${MIN_GROUP_CARDS} cards per group`);
//     }
// }


export function createDeck(initialCards) { //funcion para crear mazo a partir de cartas iniciales, si no hay suficientes crea repeticiones aleatorias
    // ensureIsValidDeck(initialCards);

    const cardNumber = initialCards.length;

    const formattedCards = initialCards.map((card) => {
        return {
            ...card,
            // originId: card.originId ?? card.id,
            id: card.id ?? getUUID(),
        }
    });

    const cloneCards = Array.from({ length: GRID_LENGTH - cardNumber }).map(() => {
        const randomCard = initialCards[Math.floor(Math.random() * cardNumber)];
        return {
            ...randomCard,
            originId: randomCard.originId,
            id: getUUID(),
            points: 0
        }
    });

    return shuffleDeck(formattedCards.concat(cloneCards));
}

export function shuffleDeck(deck) {
    const shuffledDeck = [...deck];
    for (let i = shuffledDeck.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffledDeck[i], shuffledDeck[j]] = [shuffledDeck[j], shuffledDeck[i]];
    }
    return shuffledDeck;
}

export function drawCards(deck, currentGroup) { //funcion para robar 16 cartas exactas del mazo, sabiendo cual es el grupoActual (para que aparezcan cartas del mismo)
    if (deck.length === GRID_LENGTH) return deck;
    const currentGroupCards = deck.filter((card) => card.group === currentGroup);
    const shuffledCurrentGroupCards = shuffleDeck(currentGroupCards);

    //random number between 3 and numberOfCardsOfCurrentGroup
    const randomNumberOfCards = currentGroupCards.length <= 3 ? currentGroupCards.length : Math.floor(Math.random() * (currentGroupCards.length - 1)) + 2;
    //pillar randomNuber cartas del mazo barajado con un slice
    const correctCards = shuffledCurrentGroupCards.slice(0, randomNumberOfCards);

    //draw 16 cards from the "remaining" deck
    const remainingCards = deck.filter((card) => !correctCards.includes(card));
    const numberOfRemainingCards = GRID_LENGTH - correctCards.length;
    const shuffledRemainingCards = shuffleDeck(remainingCards);
    const finalRemainingCards = shuffledRemainingCards.slice(0, numberOfRemainingCards);

    //check there's no a single card of currentGroup left, if there is, replace it with a card of another group
    const cardsLeft = shuffledRemainingCards.filter((card) => !finalRemainingCards.includes(card));
    const cardsLeftOfCurrentGroup = cardsLeft.filter((card) => card.group === currentGroup);
    if (cardsLeftOfCurrentGroup.length === 1) {
        const nonCurrentGroupElement = finalRemainingCards.find((card) => card.group !== currentGroup);
        const indexToReplace = finalRemainingCards.indexOf(nonCurrentGroupElement);
        finalRemainingCards[indexToReplace] = cardsLeftOfCurrentGroup[0];
    }

    const finalCards = [...correctCards, ...finalRemainingCards];

    return shuffleDeck(finalCards);
}